/*
 * Module for the vendor common area 
*/

rs.module("application/sections/vendor/commonarea",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls) {

            $.js(jsSelectors.idCardLink).click(_displayIdCard);

            //
            // Display the id card
            //
            var idLoaded = false;
            function _displayIdCard() {

                $(this).toggleClass(cssClasses.active);

                $.js(jsSelectors.idCard).toggle();

                if (!idLoaded) {
                    $.get(
                        backendUrls.getIdCard,
                        {
                            vendorPartyKey: $(this).data("vendorpartykey")
                        })
                        .done(function (result) {
                            $.js(jsSelectors.idCard).html(result);
                        });

                    idLoaded = true;
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);